import { SpotType } from '@/types/spot'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { storeSpotExchangeInfo } from '@/stores/spot/exchange'
import { storeSpotBinanceUserInfo } from '@/stores/spot/userInfo'
import { storeBinanceSpotTicker } from '@/stores/spot/ticker'
import { storeInsTicker } from './ins/ticker'
import { storeInsExchangeInfo } from './ins/exchange'
import { getSpotType, getSpotSymbol, getSpotInterval } from '@/hook/spot/common'

const localhostName = 'spotCtrl'

interface SpotCtrl {
  spotType: SpotType //'binanace',  // binanace, innovation
  spotSymbol: string //
  selectOrderPrice: number // 현재 선택된 값
  spotInerval: string
  setSelectOrderPrice: (price: number) => void
  changeSymbol: (spotType: string, symbol: string) => void
  setInterval: (interval: string) => void
}

const defaultSpotCtrl = {
  // spotType: 'binance' as SpotType,
  spotType: getSpotType() || 'binance',
  spotSymbol: getSpotSymbol() || 'BTCUSDT',
  spotInerval: getSpotInterval() || '1h',
}

const setChangeSymbol = (symbol: string) => {
  storeSpotExchangeInfo.getState().setExSpotSymbol(symbol)
  storeSpotBinanceUserInfo.getState().setSpotSymbol(symbol)
  storeBinanceSpotTicker.getState().setBiananceSpotSymbol(symbol)
}

export const storeSpotCtrl = create<SpotCtrl>()(
  persist(
    (set, get) => ({
      ...(defaultSpotCtrl as SpotCtrl),
      changeSymbol: (args: SpotType | string, symbol: string) => {
        const spotType = args as SpotType
        let selectOrderPrice = 0
        if (spotType === SpotType.Binance) {
          setChangeSymbol(symbol)

          selectOrderPrice = Number(storeBinanceSpotTicker.getState().headerInfo.price)
        }

        if (spotType === SpotType.Innovation) {
          /// innovation 처리하기 !!
          storeInsTicker.getState().setInsSymbol(symbol)
          storeInsExchangeInfo.getState().setExInsSymbol(symbol)

          selectOrderPrice = Number(storeInsTicker.getState().InsHeaderInfo.price)
        }

        set({
          spotType,
          spotSymbol: symbol,
          selectOrderPrice: selectOrderPrice,
        })
      },
      setSelectOrderPrice: (price: number) => {
        set({
          selectOrderPrice: price,
        })
      },
      setInterval: (interval: string) => {
        set({ spotInerval: interval })
      },
    }),
    {
      name: localhostName,
      partialize: (state) => ({
        // exSpotSybmol: state.exSpotSybmol,
        // exchangeInfo: JSON.stringify(state.exchangeInfo ? Array.from(state.exchangeInfo) : []),
        // exchangeInfo:JSON.stringify(state.exchangeInfo ? Array.from(state.exchangeInfo.values()) : []),
        // curTickInfo: state.curTickInfo ? JSON.stringify(state.curTickInfo) : null,
        spotInerval: state.spotInerval,
        spotType: state.spotType,
        spotSymbol: state.spotSymbol,
      }),
      storage: createJSONStorage(() => localStorage),
      merge: (persistedState: unknown, currentState: SpotCtrl): any => {},
    },
  ),
)
